<template>
	<div class="nav basic">
		<BackButton
			v-if="isBackBtn"
			:backNumber="backNumber"
			:backPopup="backPopup"
		/>
		<!-- 행사장행, 귀가행 예약이 모두 가능하고, 귀가행만 예약 가능인 경우 분기 처리 -->
		<div v-if="rightText" class="skip">
			<transition name="fade-out">
				<div v-if="showTooltip" class="tooltip">
					<inline-svg :src="require('@/assets/img/tooltip.svg')" />
					<span>{{ tooltipText }}</span>
				</div>
			</transition>
			<button
				type="button"
				class="btnT"
				:disabled="disabled"
				@click="clickRightText"
			>
				{{ rightText }}
			</button>
		</div>
		<h4 v-if="title">
			{{ title }}
			<span v-if="pageOrder"> ({{ pageOrder }}) </span>
		</h4>
	</div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import BackButton from '@/components/BackButton.vue';
import InlineSvg from 'vue-inline-svg';
import useBookStep from '../../composables/useBookStep';

export default {
	name: 'BaseHeader',
	components: {
		BackButton,
		InlineSvg,
	},
	props: {
		isBackBtn: {
			type: Boolean,
			default: true,
		},
		title: {
			type: String,
			default: '',
		},
		rightText: {
			type: String,
			default: '',
		},
		backNumber: {
			type: Number,
			default: -1,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		backPopup: {
			type: Boolean,
			default: false,
		},
		pageOrder: {
			type: String,
			default: '',
		},
		tooltipText: {
			type: String,
		},
	},
	setup() {
		const store = useStore();
		const route = useRoute();
		const { nextBookStep } = useBookStep();

		const clickRightText = () => {
			store.dispatch('book/CLEAR_LINES');
			nextBookStep(route.name);
			// router.push({ name: 'Backward' });
		};

		const showTooltip = ref(true);
		setTimeout(() => {
			showTooltip.value = false;
		}, 5000);

		return { showTooltip, clickRightText };
	},
};
</script>
